import { z } from "zod"

export const gtaoConfigSchema = z.object({
  radius: z.number().optional(),
  distanceExponent: z.number().optional(),
  thickness: z.number().optional(),
  scale: z.number().optional(),
  samples: z.number().optional(),
  distanceFallOff: z.number().optional(),
  screenSpaceRadius: z.boolean().optional(),
})

export const poissonDenoiseConfigSchema = z.object({
  lumaPhi: z.number().optional(),
  depthPhi: z.number().optional(),
  normalPhi: z.number().optional(),
  radius: z.number().optional(),
  radiusExponent: z.number().optional(),
  rings: z.number().optional(),
  samples: z.number().optional(),
})

export const ambientOcclusionConfigSchema = z.object({
  gtao: gtaoConfigSchema.optional(),
  denoise: poissonDenoiseConfigSchema.optional(),
})

export type AmbientOcclusionConfig = z.infer<typeof ambientOcclusionConfigSchema>

export const DEFAULT_AMBIENT_OCCLUSION_CONFIG = {
  gtao: {
    radius: 1,
    distanceExponent: 1,
    thickness: 1,
    scale: 1,
    samples: 16,
    distanceFallOff: 1,
    screenSpaceRadius: true,
  },
  denoise: {
    lumaPhi: 10,
    depthPhi: 2,
    normalPhi: 3,
    radius: 4,
    radiusExponent: 1,
    rings: 2,
    samples: 16,
  },
} as const satisfies AmbientOcclusionConfig
